module.exports = {
	"title": {
		"artist": "Escutar {artistName} no Qobuz",
		"album": "Escutar o álbum {albumName} de {artistName} no Qobuz",
		"track": "Escutar {trackName} de {artistName} no Qobuz",
		"playlist": "Escutar a playlist {playlistName} de {ownerName} no Qobuz",
		"story": "Ler artigo na Qobuz"
	},
	"buttons": {
		"listen": "Escutar no Qobuz",
		"buy": "Comprar",
		"share": "Compartilhar",
		"download": "Testar gratuitamente ",
		"readmore": "Ler mais",
		"showless": "Mostrar menos",
		"showmore": "Ver mais",
		"morealbums": "Mais álbuns no Qobuz",
		"moreplaylisttrack": "Descobrir a seguir no Qobuz",
		"readfocus": "Ler esta Panorâmica no Qobuz",
		"seeSubscribes": "Ver as ofertas de assinaturas",
		"cookies": "Parâmetro de cookies"
	},
	"infos": {
		"trackCount": "{count} faixas",
		"label": "Gravadora: {label}",
		"composer": "Compositor: {composer}",
		"producers": "Produção",
		"mixers": "Mixagem/masterização",
		"diskCount": "{count} álbuns",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "Privada",
			"public": "Pública"
		},
		"hires": "Alta qualidade",
		"available": "Disponível em"
	},
	"share": {
		"twitter": {
			"track": "Escute {title} por {artist} no Qobuz",
			"album": "Escute {title} por {artist} no Qobuz",
			"artist": "Escute {artist} no Qobuz",
			"playlist": "Escute {playlist} por {owner} no Qobuz",
			"story": "Ler artigo na Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} por {artist} está disponível no Qobuz!",
				"body": "Escute {title} de {artist} com o Qobuz em alta qualidade: {url}\n\nO Qobuz é o primeiro serviço de reprodução e de download de música em alta qualidade.\nMais informações e inscrição no qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} por {artist} está disponível no Qobuz!",
				"body": "Escute {title} de {artist} com o Qobuz em alta qualidade: {url}\n\nO Qobuz é o primeiro serviço de reprodução e de download de música em alta qualidade.\nMais informações e inscrição no qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} está no Qobuz!",
				"body": "Escute {artist} com Qobuz em alta qualidade: {url}\n\nO Qobuz é o primeiro serviço de reprodução e de download de música em alta qualidade.\nMais informações e inscrição no qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} por {owner} está disponível no Qobuz!",
				"body": "Escute {playlist} de {owner} com Qobuz em alta qualidade: {url}\n\nO Qobuz é o primeiro serviço de reprodução e de download de música em alta qualidade.\nMais informações e inscrição no qobuz.com\n\n"
			},
			"story": {
				"subject": "{title}",
				"body": "Leia o artigo {url}\n\nQobuz é o primeiro serviço de streaming de música de alta qualidade.\nPara mais informações e assinaturas acesse www.qobuz.com\n"
			}
		},
		"popup": {
			"clickToCopy": "Clique para copiar",
			"copy": "Copiar",
			"copied": "Copiado",
			"link": "Copiar o link seguinte para compartilhá-lo"
		}
	},
	"tracklist": {
		"title": {
			"track": "Faixa",
			"album": "Títulos do álbum",
			"artist": "Os melhores títulos",
			"artist_albums": "Álbuns",
			"playlist": "Títulos da playlist"
		},
		"header": {
			"number": "#",
			"name": "Título",
			"album": "Álbum",
			"artist": "Artista",
			"time": "Duração",
			"label": "Gravadora"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Nenhuma faixa disponível"
	},
	"story": {
		"404": {
			"title": "O artigo que solicitou não existe na sua área geográfica.",
			"description": "Voltar à página inicial da revista Qobuz"
		},
		"from": "Por {author}",
		"albumOverlay": "- {releaseYear} - {genre}",
		"joinQobuz": "Assine Qobuz para ler o artigo completo...",
		"signUp": "Testar gratuitamente"
	},
	"playlist": {
		"from": "Por {author}"
	},
	"album": {
		"by": "por",
		"publishedBy": "lançado por"
	},
	"notifications": {
		"nostream": "Os detentores dos direitos não permitem a reprodução desta faixa"
	},
	"aside": {
		"title": "Sobre"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/pt.json
// module id = 569
// module chunks = 0